import { styled } from "styled-components";
import { InputGroup } from "@chakra-ui/react";

export const StyledInputGroup = styled(InputGroup)`
  display: flex;

  @media screen and (max-width: 530px) {
    flex-direction: column;
   
    .input-file {
      width: 500px;
    }
  }
`;